module.exports = __webpack_public_path__ + "img/97.0f1939de.svg";